const TermsAndConditions = () => (
  <div style={{height: "100vh", width: "100vw"}}>
    <iframe
      src="/terms_condition.html"
      title="Terms and Conditions"
      width="100%"
      height="100%"
      style={{ border: "none" }}
    />
  </div>
);

export default TermsAndConditions;
